import Url from 'url-parse'

/**
 * Format a Shopify price according to store settings
 * @param {number} price - A shopify-style price (e.g. 495 as 4.95)
 */
export function formatMoney (price, neverShowCurrency = false) {
  const decimalPrice = (price / 100)
  const showCurrency = !neverShowCurrency && (window.storeSettings && window.storeSettings.show_currency)

  if (showCurrency) {
    return window.storeDefaults.moneyWithCurrency.replace('0.00', decimalPrice.toFixed(2))
  } else {
    return window.storeDefaults.money.replace('0.00', decimalPrice.toFixed(2))
  }
}

/**
 * Format a given image url to a particular size
 * @param {url} imageUrl - A shopify-style image url
 * @param {string} size - The shopify image size format
 */
export function formatImageUrl (imageUrl, size = 'small') {
  const parsedUrl = new Url(imageUrl)
  const extensions = [
    '.jpg',
    '.jpeg',
    '.gif',
    '.png'
  ]
  let imageExtension = null

  for (let ext of extensions) {
    if (parsedUrl.pathname.indexOf(ext) > -1) {
      imageExtension = ext
      break
    }
  }

  if (imageExtension) {
    parsedUrl.set('pathname', parsedUrl.pathname.replace(imageExtension, `_${size}${imageExtension}`))
  }

  return parsedUrl.toString()
}

/**
 * Format a string as per a shopify handle
 * @param {string} string - A string
 */
export function handleize (string) {
  string = string.toLowerCase()
  string = string.replace(/[^0-9a-zA-Z-]/g, '-')
  string = string.replace(/--/g, '-')
  return string
}

/**
 * Perform the same sort of escaping that liquid will do
 * @param {string} string - A string
 */
export function escape (string) {
  return string.replace(/[\u00A0-\u9999<>&]/gim, function (i) {
    return '&#' + i.charCodeAt(0) + ';'
  })
}

/**
 * Since we use a convention of identifying a group name with a colon, this function will
 * parse the string, taking into consideration a value that either also has colons, or has no group
 * @param {string} groupedString - A string containing group/value separated with a colon
 */
export function parseGroupValue (groupedString) {
  const splitString = groupedString.split(':')
  let value = ''
  let group = false

  if (splitString.length > 2) {
    group = splitString.shift()
    value = splitString.join(':')
  } else if (splitString.length === 2) {
    group = splitString[0]
    value = splitString[1]
  } else {
    value = groupedString
  }

  return {
    group,
    value
  }
}
